import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import * as appConstants from "../../constants/index";
import SweetAlertUtility from "./component/SweetAlertUtility";
import Loader from "../../assets/food/loading.gif"

export default function CinemaLauncher() {
  const location = useLocation();
  const { brand, city, cinemaId } = useParams();
  const [alertDetails, setAlertDetails] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
  });

  let dataLayer = window["dataLayer"] || [];
  const appScheme = `${brand}app://cinema/${city}/${cinemaId}`;

  const appStore =
    brand === "pvr"
      ? "https://apps.apple.com/app/id878127874"
      : "https://apps.apple.com/app/id474776230";

  // const playStoreApp =
  //   brand === "pvr"
  //     ? `market://details?id=com.net.pvr&referrer=utm_source%3Dpvrinox.com%26city%3D${encodeURIComponent(city)}%26cinemaId%3D${encodeURIComponent(cinemaId)}`
  //     : `market://details?id=com.bt.inx&referrer=utm_source%3Dinoxmovies.com%26city%3D${encodeURIComponent(city)}%26cinemaId%3D${encodeURIComponent(cinemaId)}`;

  const playStoreApp =
    brand === "pvr"
      ? `https://play.google.com/store/apps/details?id=com.net.pvr&referrer=utm_source%3Dpvrinox.com%26city%3D${encodeURIComponent(city)}%26cinemaId%3D${encodeURIComponent(cinemaId)}`
      : `https://play.google.com/store/apps/details?id=com.bt.inx&referrer=utm_source%3Dinoxmovies.com%26city%3D${encodeURIComponent(city)}%26cinemaId%3D${encodeURIComponent(cinemaId)}`;

  const websiteUrl =
    brand === "pvr"
      ? "https://www.pvrcinemas.com"
      : "https://www.inoxmovies.com";

  const brandLogos = {
    pvr: "https://res.cloudinary.com/ddnjpeeyh/image/upload/v1754995534/pvr_logo_kbfe3e.jpg",
    inox: "https://res.cloudinary.com/ddnjpeeyh/image/upload/v1754995535/inox_logo_pem2yr.jpg",
  };

  const [buttonText, setButtonText] = useState("OPEN APP");
  const [isLoading, setIsLoading] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const platform = isIOS ? "ios" : isAndroid ? "android" : "website";

  useEffect(() => {
    if (isIOS) {
      if (location.pathname.includes("cinemalauncher1")) {
        handleIpAdd();
      } else if (location.pathname.includes("cinemalauncher")) {
        setIsLoading(false);
      }
    }

    if (isAndroid) openApp();
    // else openApp();
  }, []);

  const handleIpAdd = async () => {
    setIsLoading(true)
    setButtonText("Loading...");
    try {
      // Try both in parallel
      const [res4, res6] = await Promise.allSettled([
        axios.get(`https://api4.ipify.org?format=json`),
        axios.get(`https://api6.ipify.org?format=json`)
      ]);

      const ip4 = res4.status === "fulfilled" ? res4.value?.data?.ip : null;
      const ip6 = res6.status === "fulfilled" ? res6.value?.data?.ip : null;

      if (ip4 || ip6) {
        handleAddDevice({ ip4, ip6 });
      }
    } catch (error) {
      console.error("Add Device API failed:", error);
      // sweetAlertError("Failed to fetch IP");
    }
  };

  const handleAddDevice = async ({ ip4, ip6 }) => {
    try {
      // Combine IPv4 and IPv6 into a single string
      const ipValue = [ip4, ip6].join(",");

      const response = await axios.post(
        `${appConstants.base_url}v1/booking/content/addDevice`,
        {
          theaterId: cinemaId,
          url: appStore,
          ip: ipValue
        },
        {
          headers: {
            chain: brand?.toUpperCase(),
            city: city,
            appVersion: appConstants?.av,
            platform: platform?.toUpperCase(),
          },
        }
      );

      if (response.data.responeCode === "00") {
        dataLayer.push({
          event: `deffered_link`,
          chain: brand,
          city: city,
          theaterId: cinemaId,
          platform: platform,
          url: location.href
        });
        openApp();
      } else {
        sweetAlertError("Invalid QR or Url");
      }
    } catch (error) {
      console.error("Add Device API failed:", error);
    }
  };

  const openApp = () => {
    setButtonText("Loading...");
    setButtonDisabled(true);

    const storeUrl = isIOS ? appStore : isAndroid ? playStoreApp : websiteUrl;
    let appOpened = false;

    const visibilityChangeHandler = () => {
      if (document.hidden) appOpened = true;
    };

    document.addEventListener("visibilitychange", visibilityChangeHandler);
    window.location.replace(appScheme);

    setTimeout(() => {
      if (!appOpened) {
        dataLayer.push({
          event: "deffered_link_Redirection",
          deferRedirection: platform,
          theaterId: cinemaId,
          chain: brand,
        });
        window.location.href = storeUrl;
      }
      document.removeEventListener("visibilitychange", visibilityChangeHandler);
    }, 3000);

    // Reset button after 2s
    setTimeout(() => {
      setButtonText("OPEN APP");
      setButtonDisabled(false);
      setIsLoading(false)
    }, 3000);
  };

  const sweetAlertError = (msg) => {
    setAlertDetails({
      show: true,
      type: "error",
      title: "Error!",
      message: msg,
    });
  };

  const logoUrl = brandLogos[brand?.toLowerCase()] || "";
  const hideAlert = () => setAlertDetails({ show: false });

  return (
    <>
      <div style={styles.body}>
        <div style={styles.container}>
          <div style={styles.appHeader}>
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={`${brand?.toUpperCase()} Logo`}
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 13,
                  objectFit: "contain",
                }}
              />
            ) : (
              <div style={styles.appIcon}>{brand?.toUpperCase().slice(0, 3)}</div>
            )}
            <div style={styles.appTitle}>
              {brand?.toUpperCase()} Cinemas - Movie Tickets
            </div>
          </div>

          <div style={styles.appDescription}>
            The all new {brand?.toUpperCase()} APP makes movie booking a seamless
            and hassle free experience.
          </div>

          <button
            style={{
              ...styles.openButton,
              opacity: buttonDisabled ? 0.7 : 1,
              cursor: buttonDisabled ? "not-allowed" : "pointer",
            }}
            onClick={isIOS ? handleIpAdd : openApp}
            disabled={buttonDisabled}
          >
            {buttonText}
          </button>
        </div>
      </div>
      <SweetAlertUtility
        type={alertDetails.type}
        title={alertDetails.title}
        message={alertDetails.message}
        show={alertDetails.show}
        onConfirm={hideAlert}
      />
      {isLoading &&
        <div className="loader" style={styles.loading}>
          <img src={Loader} width="120" height="120" alt="" />
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" style={{ color: "#f1f1f1" }}><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 6.99998C9.1747 6.99987 6.99997 9.24998 7 12C7.00003 14.55 9.02119 17 12 17C14.7712 17 17 14.75 17 12"><animateTransform attributeName="transform" attributeType="XML" dur="560ms" from="0,12,12" repeatCount="indefinite" to="360,12,12" type="rotate" /></path></svg> */}
          <span style={{ fontSize: 20, color: "#f1f1f1" }}>Loading...</span>
        </div>
      }
    </>
  );
}

const styles = {
  body: {
    background: "#f5f5f5",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
  },
  container: {
    maxWidth: 400,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  loading: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgb(0 0 0 / 73%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    backdropFilter: "blur(2px)",
  },
  appHeader: {
    display: "flex",
    alignItems: "center",
    gap: 15,
    marginBottom: 40,
    alignSelf: "flex-start",
  },
  appIcon: {
    width: 60,
    height: 60,
    background: "linear-gradient(135deg, #FFB800 0%, #FF8C00 100%)",
    borderRadius: 13,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 20,
    fontWeight: "bold",
    color: "white",
  },
  appTitle: {
    fontSize: 24,
    fontWeight: 400,
    color: "#000",
    lineHeight: 1.2,
  },
  appDescription: {
    color: "#8E8E93",
    fontSize: 17,
    lineHeight: 1.4,
    marginBottom: 50,
    textAlign: "left",
    alignSelf: "flex-start",
  },
  openButton: {
    background: "white",
    color: "#007AFF",
    border: "1px solid #E5E5EA",
    padding: "12px 24px",
    borderRadius: 12,
    fontSize: 17,
    fontWeight: 600,
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    transition: "all 0.2s ease",
    minWidth: 100,
    letterSpacing: 0.5,
  },
};
